export const deliveryTrackingURLs = {
  // customer delivery onboard
  GET_CUSTOMER: 'delivery/customer/all?',
  ADD_CUSTOMER: 'delivery/customer/add',
  UPDATE_CUSTOMER: 'delivery/customer/update',
  DELETE_CUSTOMER: 'delivery/customer/delete',

  //delivery tracking
  DELIVERY_TRIPS_COUNT: 'delivery/get/count/trips?',
  DELIVERY_TRIPS: 'delivery/trips/filter?',
  ORDERS_LIST: 'delivery/list?',
  DELIVERY_ROUTES: `delivery/route`,
  ADD_DELIVERY_TRIP: `/delivery/trips`,
  DRIVER_DROPDOWN: `trip/available`,
  CONTACT_NUMBER: `delivery/numbers/dropdown`,
  CONTACT_DATA: `delivery/customer/detail`,
  DELIVERY_AND_ORDERS: `delivery/trips`,
  UPDATE_DELIVERY: `delivery/update/trip`,
  ORDER_STATUS: `delivery/order/details?`,
  ORDER_BY_STATUS: `delivery/rescheduled/orders?`,
  RESCHEDULE_TRIPS_LIST: `delivery/trip/dropdown`,
  TRIPS_ORDERS_REASSIGN: `delivery/assign/orders`,
  DELIVERY_TRIP_PREVIEW: `delivery/trips/preview`,

  GET_ORDERS: `delivery/orders/get?`,

  //khub
  DELETE_KHUB_TRIP: 'delivery/trip/delete?',

  //Add Loads
  ADD_LOAD: 'delivery/load/add',
  DELETE_LOAD: 'delivery/load/delete',
  UPDATE_LOAD: 'delivery/load/update',
  GET_ORDERS_FILTER_LIST: 'delivery/load/orders/count',
  FILTERED_ORDER: 'delivery/load/orders/get',
  DEACTIVE_LOAD: 'delivery/load/deactivate',
  // GET_ORDER_LOADCONFIG: 'delivery/order/loadConfig/get',
  GET_ORDER_LOADCONFIG: 'delivery/order/get/loadConfig',

  ADD_LOAD_CONFIG: 'delivery/load/config/add',
  GET_LOAD_CONFIG: 'delivery/loadConfig/get/all',
  UPDATE_LOAD_CONFIG: 'delivery/load/config/update',
  DELETE_LOAD_CONFIG: 'delivery/load/config/delete',
  DEACTIAVTE_LOAD_CONFIG: 'delivery/loadConfig/deactivate',

  GET_ORDER_LOADCONFIG_DIMENSIONS: 'delivery/load/config/get',

  // //

  // UPDATE_LOAD_CONFIG: 'delivery/load/config/update',
  // DELETE_LOAD_CONFIG: 'delivery/load/config/delete',

  GET_LOAD: 'delivery/load/get',
  // dispatch
  GET_LOADS_DROPDOWN: 'delivery/dispatch/loads/dropdown',
  GET_DISPATCH_PREVIEW: 'delivery/dispatch/preview',
  GET_TRUCKS_DROPDOWN: 'delivery/dispatch/get/vehicleList',
  GET_DRIVER: 'trip/available?',
  ADD_DELIVERY_DISPATCH: 'delivery/dispatch/add',
  GET_ALL_DISPATCH: 'delivery/dispatch/get?',
  DEACTIVATE_DISPATCH: 'delivery/dispatch/activate?',
  DELETE_DISPATCH: 'delivery/dispatch/delete?',
  VIEW_DISPATCH: 'delivery/dispatch/get/loads?',
  UPDATE_DELIVERY_DISPATCH: 'delivery/dispatch/update',
  GET_DELIVERY_VEHICLE: 'user/report/devices',

  //Order
  GET_ORDER_COUNT: 'delivery/orders/count',
  ADD_EXCEL: `delivery/orders/upload`,
  ADD_ORDER: 'delivery/orders/add',
  DELETE_ORDER: 'delivery/orders/delete'
};
